import APIService from '../api';

import {
  IGenerateBrandedCoinsResponse,
  ILoyaltyAndGiftPercentageRecommendationResponse,
  IOfferRecommendationResponse,
  IOfferResponse
} from '@/models/smart-business-signup';

const PREFIX = '/smart-business-signup';

export default class SmartBusinessSignup extends APIService {
  host() {
    if (window.location.hostname === 'localhost') {
      return process.env.VUE_APP_API_URL;
    }

    return 'https://api.twism.com'; // Smart routes will be available only in the prod environment at this initial stage.
  }

  loyaltyAndGiftPercentageRecommendation(category: string) {
    return this.post<ILoyaltyAndGiftPercentageRecommendationResponse>(
      `${PREFIX}/loyalty-and-gift-percentage-recommendation`,
      {
        category
      }
    );
  }
  generateBrandedCoins(googlePlaceId: string) {
    return this.post<IGenerateBrandedCoinsResponse>(
      `${PREFIX}/generate-branded-coins`,
      {
        googlePlaceId
      }
    );
  }
  offerRecommendation(googlePlaceId: string) {
    return this.post<IOfferRecommendationResponse>(
      `${PREFIX}/offer-recommendation`,
      {
        googlePlaceId
      }
    );
  }
  offerRecommendationFallback(loyaltyPercentage: number) {
    return this.post<IOfferResponse>(
      `${PREFIX}/offer-recommendation-fallback`,
      {
        loyaltyPercentage
      }
    );
  }
}
